export default "__VITE_ASSET__7VYnsmhO__"